import { DropdownOption } from '../../types/jbForm.types';

export const targetingOptions: DropdownOption[] = [
  { value: 'I', label: 'I' },
  { value: 'M', label: 'M' },
  { value: 'N', label: 'N' },
  { value: 'F', label: 'F' },
];

export const TemplateTargetingLegend = {
  I: 'Sends to target users who follow the channel',
  M: 'Sends to all marketing-consented target users, including non-followers',
  N: "Sends to marketing-consented target users who don't follow the channel",
  F: 'Sends to all channel followers',
};
